import { MNSproCloudApi } from '../..';
import { FileDownload, FileMetadata, Recipient, ShareContent } from '../api/v2';

export class ParentalCommunicationFilesService {
  private constructor() {}

  private static getApi(authToken: string) {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.ParentalCommunicationApiFactory(config);
    return api;
  }

  static async getFolderContents(
    authToken: string,
    organizationId: string,
    folderId?: string,
  ): Promise<FileMetadata[]> {
    const api = ParentalCommunicationFilesService.getApi(authToken);
    const response = await api.getAllFilesMetadata(organizationId, folderId);
    return response.data;
  }

  static async createFolder(
    authToken: string,
    organizationId: string,
    folderName: string,
    recipients: Recipient[] | null,
    parentFolderId?: string,
  ): Promise<FileMetadata> {
    const api = ParentalCommunicationFilesService.getApi(authToken);
    const shareWithOrganization = recipients === null;
    const response = await api.createFolder(
      organizationId,
      folderName,
      parentFolderId,
      recipients === null
        ? undefined
        : recipients
            .map(r => r.id)
            .filter((id): id is string => id !== undefined),
      shareWithOrganization,
    );
    return response.data;
  }

  static async createFile(
    authToken: string,
    organizationId: string,
    contentFolderId: string | undefined,
    recipients: string[] | null,
    contentShareWithOrganization: boolean,
    file: File,
    timePeriod: string,
  ): Promise<FileMetadata> {
    const api = ParentalCommunicationFilesService.getApi(authToken);

    const response = await api.createFile(
      organizationId,
      contentFolderId,
      recipients === null ? undefined : recipients,
      contentShareWithOrganization,
      false, // contentOverwrite
      timePeriod,
      file,
    );
    return response.data;
  }

  static async deleteFile(
    authToken: string,
    organizationId: string,
    fileId: string,
  ): Promise<boolean> {
    const api = ParentalCommunicationFilesService.getApi(authToken);
    try {
      await api.deleteFile(organizationId, fileId);
      return true;
    } catch {
      return false;
    }
  }

  static async changeFileSharingList(
    authToken: string,
    organizationId: string,
    fileId: string,
    recipients: string[] | null,
  ): Promise<boolean> {
    try {
      const api = ParentalCommunicationFilesService.getApi(authToken);
      const shareContent: ShareContent = {
        fileId,
        recipients,
        shareWithOrganization: recipients === null,
      };
      const response = await api.changeFileSharingList(
        organizationId,
        shareContent,
      );

      return response.data;
    } catch {
      return false;
    }
  }

  static async getDownloadLink(
    authToken: string,
    organizationId: string,
    fileId: string,
  ): Promise<FileDownload> {
    const api = ParentalCommunicationFilesService.getApi(authToken);
    const response = await api.getFile(organizationId, fileId);

    return response.data;
  }
}
